import barba from '@barba/core'
import { headerBrandClass, header } from './_constants'
import { throttle } from './_helpers'

let prevNeedChange = null
let sections = Array.from(document.querySelectorAll('[data-brand-header]'))

const throttledHeaderChange = throttle(() => {
  const fromTop = window.scrollY
  const needChange = sections.some(
    s =>
      s.offsetTop - header.clientHeight <= fromTop &&
      s.offsetTop + s.offsetHeight - header.clientHeight > fromTop
  )

  if (needChange === prevNeedChange) {
    return
  }

  header.classList.toggle(headerBrandClass, needChange)

  prevNeedChange = needChange
}, 100)

export default function headerChangeOnScroll() {
  barba.hooks.leave(() => {
    window.removeEventListener('scroll', throttledHeaderChange)
  })

  barba.hooks.enter(() => {
    sections = Array.from(document.querySelectorAll('[data-brand-header]'))

    window.addEventListener('scroll', throttledHeaderChange)
    throttledHeaderChange()
  })

  window.addEventListener('scroll', throttledHeaderChange)
  throttledHeaderChange()
}
